export const ADMIN_SYSTEM_NAME = "RainChat 后台管理系统";

export function getAdminLocale(countryId) {
  const locales = { 3: "zh-TW", 4: "id", 5: "ms", 6: "vi" };
  return locales[Number(countryId)] || "en";
}

// 新增后台页面时，只需在这里补充菜单项，并在 router/modules/admin.js 注册对应子路由。
export const ADMIN_MENU = [
  {
    key: "bd-management",
    label: "BD 管理",
    labelKey: "admin.menu.bd",
    icon: "BD",
    routeName: "bdManagement",
    roles: ["BDM"],
  },
  {
    key: "guild-management",
    label: "Agency 管理",
    labelKey: "admin.menu.guild",
    icon: "G",
    routeName: "guildManagement",
    roles: ["BDM", "BD"],
  },
  {
    key: "anchor-management",
    label: "Host 管理",
    labelKey: "admin.menu.anchor",
    icon: "A",
    routeName: "anchorManagement",
    roles: ["公会长"],
  },
  {
    key: "anchor-data",
    label: "Host 数据",
    labelKey: "admin.menu.data",
    icon: "D",
    routeName: "anchorData",
    roles: ["BDM", "BD"],
  },
];

export function getAdminLandingRouteName(roles) {
  const availableMenu = ADMIN_MENU.find((item) => item.roles.some((role) => roles.includes(role)));
  return availableMenu ? availableMenu.routeName : null;
}

export function getAdminUserRoles(user) {
  if (Array.isArray(user.roles)) return user.roles;
  const role = user.role || "";
  return [
    role.includes("BDM") && "BDM",
    role.includes("BD") && "BD",
    (role.includes("公会长") || role.includes("公会管理员")) && "公会长",
  ].filter(Boolean);
}

// 将登录接口返回的 data 映射为后台布局展示用的用户信息。
// token 一并保留在 user 里，供 adminApi 在后续后台接口的请求头中注入。
export function mapAdminUser(data) {
  const roles = [];
  if (data.is_bdm) roles.push("BDM");
  if (data.is_bd) roles.push("BD");
  if (data.is_union_leader) roles.push("公会长");

  const displayName = data.nick_name || data.user_name || "";

  return {
    id: data.user_id,
    name: displayName,
    role: roles.length ? roles.join(" · ") : "管理员",
    roles,
    avatar: data.head_pic || "",
    avatarText: displayName.slice(0, 1) || "U",
    token: data.token,
    countryId: data.country_id,
  };
}
